export const getSessionFromCookie = () => {
  const value = `; ${document.cookie}`;
  const parts = value.split('; __session=');
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() ?? '';
  }

  return '';
};
